import React from "react";

// Token & elemen dasar panel Admin (tema terang Jawsel: kartu putih, aksen Medium Blue)
export const D = {
  blue: "#0000CD", blueSoft: "#e6e6fa", dark: "#1c1c1c", ink: "#141414",
  sub: "#8a8776", chip: "#d6f2e2", chipInk: "#189a5b", line: "#ece9dc", gray: "#b9b6a6",
  cream: "#f4f1e6", danger: "#dc2626", dangerSoft: "#fecaca", warn: "#b7791f", warnSoft: "#fdf1d6",
};
export const JAKARTA = "'Plus Jakarta Sans', sans-serif";

export const inputStyle = {
  padding: "11px 14px", background: D.cream, border: `1.5px solid ${D.line}`, borderRadius: 14, color: D.ink,
  fontSize: 13, outline: "none", fontFamily: JAKARTA, minWidth: 0, width: "100%", boxSizing: "border-box",
};

export function Card({ children, style, testid }) {
  return (
    <div data-testid={testid} style={{ background: "#fff", borderRadius: 26, padding: "20px 22px", boxShadow: "0 8px 22px rgba(20,20,20,0.05)", ...style }}>
      {children}
    </div>
  );
}

export function SectionTitle({ title, sub, right }) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, marginBottom: 14 }}>
      <div>
        <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, letterSpacing: -0.4, color: D.ink }}>{title}</h3>
        {sub && <p style={{ margin: "4px 0 0", fontSize: 12.5, color: D.sub }}>{sub}</p>}
      </div>
      {right}
    </div>
  );
}

export function Btn({ children, variant = "primary", small, testid, type = "button", ...rest }) {
  const base = { display: "inline-flex", alignItems: "center", gap: 7, border: 0, borderRadius: 99, fontWeight: 700, fontFamily: JAKARTA, cursor: "pointer", transition: "opacity .15s, background-color .15s", whiteSpace: "nowrap" };
  const size = small ? { padding: "6px 14px", fontSize: 12 } : { padding: "10px 20px", fontSize: 13 };
  const variants = {
    primary: { background: D.blue, color: "#fff" },
    soft: { background: D.blueSoft, color: D.blue },
    ghost: { background: "#fff", color: D.ink, border: `1.5px solid ${D.line}` },
    danger: { background: "#fff", color: D.danger, border: `1.5px solid ${D.dangerSoft}` },
    dark: { background: D.dark, color: "#fff" },
  };
  return (
    <button type={type} data-testid={testid} style={{ ...base, ...size, ...variants[variant], ...(rest.disabled ? { opacity: .5, cursor: "not-allowed" } : {}) }}
      onMouseEnter={e => { if (!rest.disabled) e.currentTarget.style.opacity = "0.85"; }} onMouseLeave={e => { e.currentTarget.style.opacity = "1"; }} {...rest}>
      {children}
    </button>
  );
}

export function Chip({ children, tone = "green", testid }) {
  const tones = {
    green: { background: D.chip, color: D.chipInk }, blue: { background: D.blueSoft, color: D.blue },
    gray: { background: D.cream, color: D.sub }, red: { background: "#fee2e2", color: D.danger }, amber: { background: D.warnSoft, color: D.warn },
  };
  return <span data-testid={testid} style={{ display: "inline-block", padding: "3px 10px", borderRadius: 99, fontSize: 11, fontWeight: 800, letterSpacing: .3, whiteSpace: "nowrap", ...tones[tone] }}>{children}</span>;
}

export function Field({ label, children, grow }) {
  return (
    <label style={{ display: "flex", flexDirection: "column", gap: 6, flex: grow ? 1 : undefined, minWidth: grow ? 180 : undefined }}>
      <span style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1.2, textTransform: "uppercase", color: D.sub }}>{label}</span>
      {children}
    </label>
  );
}

export function Toggle({ on, onChange, testid, label }) {
  return (
    <button type="button" data-testid={testid} role="switch" aria-checked={on} aria-label={label} onClick={() => onChange(!on)}
      style={{ width: 40, height: 22, borderRadius: 99, border: 0, padding: 2, cursor: "pointer", background: on ? D.blue : D.gray, transition: "background-color .15s", flex: "none" }}>
      <span style={{ display: "block", width: 18, height: 18, borderRadius: 99, background: "#fff", transform: `translateX(${on ? 18 : 0}px)`, transition: "transform .15s" }} />
    </button>
  );
}

export function Msg({ text, tone = "green", testid }) {
  if (!text) return null;
  return <Chip tone={tone} testid={testid}>{text}</Chip>;
}

export const fmtTime = iso => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};
export const fmtSize = n => (n == null ? "" : n > 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.round(n / 1024)} KB`);

// Status akun warga (Kartu Warga) → [tone chip, label] & nama kota kapital — dipakai Panel Warga, detail, Pesan Warga
export const STATUS_WARGA = { menunggu: ["amber", "Menunggu DM"], terverifikasi: ["green", "Warga Asli"], diblokir: ["red", "Diblokir"] };
export const namaKota = id => (id ? id.charAt(0).toUpperCase() + id.slice(1) : "—");
